/* eslint-disable no-shadow,  no-param-reassign */
import Hls from 'hls.js';
import {
  formatUrl,
  parseUrl,
} from './proxy';

class hlsLoader extends Hls.DefaultConfig.loader {
  constructor(config) {
    super(config);
    const load = this.load.bind(this);
    this.load = (context, config, callbacks) => {
      const { onSuccess } = callbacks;
      callbacks.onSuccess = (response, stats, context) => {
        onSuccess(
          { ...response, url: parseUrl(response.url) },
          stats,
          { ...context, url: parseUrl(context.url) },
        );
      };
      load({ ...context, url: formatUrl(context.url) }, config, callbacks);
    };
  }
}

export default hlsLoader;
